import { unified }   from 'unified'
import remarkParse   from 'remark-parse'
import remarkGfm     from 'remark-gfm'

export interface TocEntry {
  level: number
  text:  string
  slug:  string
}

interface MdNode {
  type:     string
  children?: MdNode[]
  value?:   string
  depth?:   number
}

function extractText(node: MdNode): string {
  if (node.type === 'text' || node.type === 'inlineCode') return node.value ?? ''
  return (node.children ?? []).map(extractText).join('')
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '')
}

export function parseTOC(content: string): TocEntry[] {
  const tree = unified().use(remarkParse).use(remarkGfm).parse(content) as unknown as MdNode
  const entries: TocEntry[] = []

  for (const node of tree.children ?? []) {
    if (node.type === 'heading') {
      const text = extractText(node)
      if (text) entries.push({ level: node.depth ?? 1, text, slug: slugify(text) })
    }
  }

  return entries
}
